module.exports = __webpack_public_path__ + "static/media/1200px-Speaker_Icon.c6b65171.png";